import React from 'react'
import heroImage from '../../../assets/img/hero.svg'
import HeroText from './HeroText'

const HeroDesktop: React.FC = () => {
  return (
    <section className="relative w-full h-[80vh] bg-black text-white flex overflow-visible 2xl:justify-center mb-[140px]">
      <div className="w-1/2 flex flex-col justify-center pl-20 pr-10 z-10 2xl:mr-[300px]">
        <HeroText />
      </div>
      
      <div className="
      w-1/2 
      flex 
      items-end 
      justify-end 
      absolute 
      right-[0%] 
      bottom-[-20%] 
      z-20 
      p-10 
      ">
        <img 
          src={heroImage} 
          alt="Zuchy book characters" 
          className="
          w-full 
          max-w-none 
          object-top
          "
        />
      </div>
    </section>
  )
}

export default HeroDesktop
